import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Alert from '../../../../../../components/global/Alert';
import { getFormikTouchedErrors } from '../../../../../../util/formik';
import AlbumFolderBranding from '../../AlbumFolderSettings/AlbumFolderBranding';
import Label from '../../../../../../components/global/Label';
import { sanitizeHashCode } from '../../../../../../util/text';
import InputGroup from '../../../../../../components/global/InputGroup';
import DiamondUpgradeButton from '../../WeddingEventCreateWizard/components/DiamondUpgradeButton';

const propTypes = {
  values: PropTypes.shape({
    hash_code: PropTypes.string,
  }).isRequired,
  touched: PropTypes.object,
  errors: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func,
  hashCodeEnabled: PropTypes.bool,
  watermarkEnabled: PropTypes.bool,
  onUpgrade: PropTypes.func,
};

const WeddingEventSocialDetails = ({
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
  hashCodeEnabled = true,
  watermarkEnabled = true,
  onUpgrade,
}) => {
  const errorList = Object.values(getFormikTouchedErrors(errors, touched));

  return (
    <Fragment>
      <InputGroup
        id="hash_code"
        name="hash_code"
        label={
          <span className="d-flex">
            Add a hashtag for Facebook posts!
            {onUpgrade && !hashCodeEnabled && (
              <DiamondUpgradeButton onUpgrade={onUpgrade} />
            )}
          </span>
        }
        labelType="expanded"
        placeholder="MyWeddingHashtag"
        onChange={event => {
          handleChange({
            target: {
              name: 'hash_code',
              value: sanitizeHashCode(event.target.value),
            },
          });
        }}
        onBlur={handleBlur}
        value={values.hash_code}
        addon="#"
        disabled={!hashCodeEnabled}
      />

      <div className="disabled">
        <Label id="brand-filter" labelType="expanded">
          <span className="d-flex">
            Add a custom photo overlay to your photos!{' '}
            {onUpgrade && !watermarkEnabled && (
              <DiamondUpgradeButton onUpgrade={onUpgrade} />
            )}
          </span>
        </Label>
        <AlbumFolderBranding
          values={values}
          errors={errors}
          handleChange={handleChange}
          handleBlur={handleBlur}
          touched={touched}
          disabled={!watermarkEnabled}
        />
      </div>

      {errorList.length > 0 && (
        <Alert type="danger" className="mt-1 text-normal">
          <ul className="mb-0">
            {errorList.map(error => (
              <li key={error}>{error}</li>
            ))}
          </ul>
        </Alert>
      )}
    </Fragment>
  );
};

WeddingEventSocialDetails.propTypes = propTypes;

export { WeddingEventSocialDetails as EventShutterbugDetailsComp };

export default WeddingEventSocialDetails;
